






































































































































































































































































import { Component, Emit, Prop } from 'vue-property-decorator'
import { format, isBefore, parse, parseISO } from 'date-fns'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import Vue from 'vue'
import Apis from '@/Apis/_'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import { minutesToHours } from '@/utils/common'
import { HorariosDisponiveisPorDiaProps,
  SearchSchedulingPayloadProps,
  SlotPayloadProps } from '@/types/interfaces/SolicitacaoCirurgia'
import ReservaSalaStore from '../ReservaSala/Store/ReservaSalaStore'

type FilterProps = {
  date: string
  days: string[]
  initialHour: string
  finalHour: string
}

@Component
export default class ModalRoomScheduling extends Vue {
  @Prop({ type: Boolean, required: true }) readonly visible!: boolean

  datePickerMenu: boolean = false
  datePicker: string = ''
  filterData: FilterProps = {
    date: '',
    days: [],
    finalHour: '',
    initialHour: '',
  }

  modalInitialHour: boolean = false
  modalFinalHour: boolean = false

  daysOptions = [
    { text: 'Domingo', value: '1' },
    {
      text: '2° feira',
      value: '2',
    },
    {
      text: '3° feira',
      value: '3',
    },
    {
      text: '4° feira',
      value: '4',
    },
    {
      text: '5° feira',
      value: '5',
    },
    {
      text: '6° feira',
      value: '6',
    },
    {
      text: 'Sábado',
      value: '7',
    },
  ]

  hasSchedulingActive: boolean = false
  dateTitle: string = ''
  horariosDisponiveisPorDia: HorariosDisponiveisPorDiaProps[]
  isSearchLoading = false
  isCentroCirurgicoLoading = false
  centroCirurgicoId: string = ''
  tipoSalaId: string = ''
  roomTypes: string[]
  allDaysSelected: boolean = false

  updateDate(date: string) {
    this.filterData.date = format(parseISO(date), 'dd/MM/yyyy')
    this.datePicker = date
  }

  allowedDates(date: string): boolean {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const selectedDate = parseISO(date)
    return !isBefore(selectedDate, today)
  }

  saveFilter() {
    localStorage.setItem(
      '@finx:room_scheduling_filter',
      JSON.stringify(this.filterData),
    )
  }

  resetFields() {
    this.filterData = {
      date: '',
      days: [],
      finalHour: '',
      initialHour: '',
    }
    this.centroCirurgicoId = ''
    this.roomTypes = []
    this.horariosDisponiveisPorDia = []
  }

  setSavedFilters() {
    const localStorageFilters = localStorage.getItem(
      '@finx:room_scheduling_filter',
    )
    if (localStorageFilters) {
      this.filterData = JSON.parse(localStorageFilters)
      return
    }
    this.resetFields()
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get solicitacaoCirurgia() {
    return this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia
  }

  get getCentroCirurgico() {
    return this.getSolicitacaoCirurgiaStore.centroCirurgico
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get firstOptionSurgeryDate() {
    return (
      this.solicitacaoCirurgia.opcaoDataPrevisto1
      && moment(this.solicitacaoCirurgia.opcaoDataPrevisto1).format(
        'DD-MM-yyyy HH:mm',
      )
    )
  }

  get reservaSalaId() {
    return this.getSolicitacaoCirurgiaStore.reservaSalaId
  }

  set reservaSalaId(value: string) {
    this.getSolicitacaoCirurgiaStore.setReservaSalaId(value)
  }

  minutesToHoursUtil(value) {
    return minutesToHours(value)
  }

  onSelectCentroCirurgico(centroCirurgicoSelectedId: string) {
    this.roomTypes = []
    this.tipoSalaId = ''

    const centroCirurgicoSelected = this.getReservaSalaStore.centrosCirurgicos.find(
      item => item.id === centroCirurgicoSelectedId,
    )

    if (centroCirurgicoSelected) {
      const uniqueRoomTypes = new Set<string>()

      centroCirurgicoSelected.salas.forEach((sala) => {
        if (sala.ativa && sala.tipo) {
          uniqueRoomTypes.add(sala.tipo)
        }
      })

      this.roomTypes = Array.from(uniqueRoomTypes)
    }
  }

  formatDateToIso(date: string) {
    const parsedDate = parse(date, 'dd/MM/yyyy', new Date())
    parsedDate.setHours(12, 0, 0, 0)

    return parsedDate.toISOString()
  }

  addDaysToDate(dateString: string, daysToAdd: number = 15): string {
    const [day, month, year] = dateString.split('/').map(Number)

    const date = new Date(year, month - 1, day)

    date.setDate(date.getDate() + daysToAdd)

    const newDay = date.getDate().toString().padStart(2, '0')
    const newMonth = (date.getMonth() + 1).toString().padStart(2, '0')
    const newYear = date.getFullYear()

    return `${newDay}/${newMonth}/${newYear}`
  }

  async onSearchScheduling() {
    this.isSearchLoading = true
    this.hasSchedulingActive = false
    const searchSchedulingPayload: SearchSchedulingPayloadProps = {
      Data: this.formatDateToIso(this.filterData.date),
      Dia: this.filterData.days,
      HoraFim: this.filterData.finalHour,
      HoraInicio: this.filterData.initialHour,
      TempoCirurgico: String(this.solicitacaoCirurgia.tempoCirurgia),
      CentroCirurgicoId: this.centroCirurgicoId || '',
      TipoDeSala: this.tipoSalaId,
      SolicitacaoId: this.solicitacaoCirurgia.id,
    }
    try {
      const { data } = await Apis.Agendamento.SolicitacaoCirurgiaApi.getReservaGrade(
        this.solicitacaoCirurgia.hospitalId,
        this.solicitacaoCirurgia.medicoSolicitanteId,
        searchSchedulingPayload,
      )
      this.dateTitle = this.filterData.date
      this.horariosDisponiveisPorDia = data.horariosDisponiveisPorDia
    } catch (error) {
      console.log(error)
    } finally {
      this.isSearchLoading = false
    }
  }

  formatDateWithHour(dateStr: string, initialHour: string): string {
    if (!dateStr || !initialHour) return ''
    const date = new Date(dateStr)

    const [hour, minute] = initialHour.split(':').map(Number)

    date.setUTCHours(hour, minute, 0, 0)

    const formattedDate = date.toISOString().slice(0, 19)

    return formattedDate
  }

  onClickSlot(slotPayload: SlotPayloadProps, dateSelected) {
    if (
      typeof dateSelected !== 'string'
      || !slotPayload.slotSelected
      || !slotPayload.slotSelected.horaInicio
    ) return
    const dateFormated = this.formatDateWithHour(
      dateSelected,
      slotPayload.slotSelected.horaInicio,
    )
    if (dateFormated) {
      this.solicitacaoCirurgia.opcaoDataPrevisto1 = dateFormated
      this.solicitacaoCirurgia.opcaoDataPrevisto2 = ''
      this.solicitacaoCirurgia.opcaoDataPrevisto3 = ''
      this.reservaSalaId = slotPayload.salaId
      this.solicitacaoCirurgia.centroCirurgicoId = slotPayload.centroCirurgicoId
      this.hasSchedulingActive = true
      this.close()
    }
  }

  onCancelSlotScheduling() {
    this.solicitacaoCirurgia.opcaoDataPrevisto1 = ''
    this.hasSchedulingActive = false
  }

  onChangeFilterDate(operation: 'sum' | 'decrease') {
    const [day, month, year] = this.dateTitle.split('/').map(Number)

    const date = new Date(year, month - 1, day)

    if (operation === 'sum') {
      date.setDate(date.getDate() + 15)
    } else if (operation === 'decrease') {
      date.setDate(date.getDate() - 1)
    }

    const adjustedDay = String(date.getDate()).padStart(2, '0')
    const adjustedMonth = String(date.getMonth() + 1).padStart(2, '0')
    const adjustedYear = date.getFullYear()
    this.filterData.date = `${adjustedDay}/${adjustedMonth}/${adjustedYear}`
    this.onSearchScheduling()
  }

  centroCirurgicoOptions() {
    const options: { text: string; value: string }[] = []
    this.getCentroCirurgico.forEach((item) => {
      options.push({
        text: item.nome,
        value: item.id,
      })
    })
    return options
  }

  isBeforeToday(dateString: string): boolean {
    if (!dateString) return true

    const [day, month, year] = dateString.split('/').map(Number)

    const inputDate = new Date(year, month - 1, day)

    const today = new Date()
    const currentDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    )

    return inputDate.getTime() < currentDate.getTime()
  }

  isToday(dateString: string): boolean {
    if (!dateString) return true

    const [day, month, year] = dateString.split('/').map(Number)

    const inputDate = new Date(year, month - 1, day)

    const today = new Date()
    const currentDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    )

    return inputDate.getTime() === currentDate.getTime()
  }

  onDaysChange(selectedDays) {
    if (
      !this.allDaysSelected
      && selectedDays.length === this.daysOptions.length
    ) {
      this.allDaysSelected = true
    } else if (
      this.allDaysSelected
      && selectedDays.length !== this.daysOptions.length
    ) {
      this.allDaysSelected = false
    }
  }

  toggleAllDays() {
    if (this.allDaysSelected) {
      this.filterData.days = []
    } else {
      this.filterData.days = this.daysOptions.map(day => day.value)
    }
    this.allDaysSelected = !this.allDaysSelected
  }

  mounted() {
    this.setSavedFilters()
  }

  @Emit('close')
  close() {
    this.$emit('close')
    this.setSavedFilters()
    this.horariosDisponiveisPorDia = []
    this.hasSchedulingActive = false
  }
}
